import { createContext, useContext } from 'react';

// Lets a page take over the AppShell sidebar slot in place of the default
// DashboardSidebar. Pages call setHasOverride(true) on mount and use
// createPortal(node, slotEl) to render their own sidebar content.
//
// Why a portal (not state-stored JSX): the page keeps full hooks/state
// ownership of its sidebar tree, and React diffs work normally.
export const SidebarSlotContext = createContext({
  slotEl: null,
  setHasOverride: () => {},
});

export function useSidebarSlot() {
  return useContext(SidebarSlotContext);
}
